import React from "react";
import CardSuccessDanger from "./CardSuccessDanger";
import { CardContainerDescription } from "./CardContainerDescription";

const ResumenValidado = ({ validation }) => {
    let msgDanger = "";
    let encontrado = false;
    const hashArchivo = validation.digests.map(h=> h.hash)
    const enFecha =
        validation.timeStampValidation.tokenInfo.genTime >= validation.timeStampValidation.certInfo.notBefore &&
        validation.timeStampValidation.tokenInfo.genTime <= validation.timeStampValidation.certInfo.notAfter;

    const opciones = { month: 'numeric', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false, timeZoneName: 'short', timeZone: 'UTC' };

    const fechaTST = validation.timeStampValidation.tokenInfo.genTime;

    const subject = validation.timeStampValidation.certInfo.subject.replaceAll("/", "\n");
    const issuer = validation.timeStampValidation.certInfo.issuer.replaceAll("/", "\n");
    const Serialdecimal = parseInt(validation.timeStampValidation.tokenInfo.serial.toString(), 16);
    
   
    if (hashArchivo.length === 0) {
        msgDanger = "No se ha subido el archivo a comprobar.";
        encontrado = false;
    } else {
        encontrado = hashArchivo !== validation.timeStampValidation.tokenInfo.hash;
        msgDanger = encontrado ? "El archivo subido no se corresponde con el archivo al que se le aplicó el sello de tiempo." : "";
    }
    
    return (
        <div className="mainResultado">
            <h1>Resultado de Validacion</h1>
            <div>
                <CardSuccessDanger valid={enFecha} success={"Válido"} danger={"Este certificado está caducado"} />
                <h3>Información del certificador</h3>
                <CardSuccessDanger valid={validation.timeStampValidation.caValidation.coloriuris} success={"Certificado de Coloriuris"} danger={"No es de Coloriuris"} />
                <CardSuccessDanger valid={!validation.timeStampValidation.caValidation.revoked} success={"El certificado es correcto"} danger={"El certificado está revocado"} />
                <CardContainerDescription titulo="Emisor del firmador" descripcion={issuer} />
                <CardContainerDescription titulo="Firmador del Sello" descripcion={subject} />
                <CardContainerDescription titulo="Fecha válido"
                    descripcion={validation.timeStampValidation.certInfo.notBefore.toLocaleDateString('es-ES', opciones) 
                    + " " + validation.timeStampValidation.certInfo.notBefore.toLocaleTimeString('es-ES')
                    + " " + validation.timeStampValidation.certInfo.notAfter.toLocaleDateString('es-ES', opciones) 
                    + " " + validation.timeStampValidation.certInfo.notAfter.toLocaleTimeString('es-ES')} />
                <h3>Información del Sello</h3>
                <CardContainerDescription titulo="Fecha del sello" descripcion={fechaTST.toLocaleDateString("es-ES", opciones) + " " + fechaTST.toLocaleTimeString('es-ES')} />
                <CardContainerDescription titulo="Número de serie" descripcion={Serialdecimal.toString()} />
                <CardContainerDescription titulo="Algoritmo de firma" descripcion={validation.timeStampValidation.tokenInfo.alg} />
            </div>
            <div>
                <h3>Validación</h3>
                <CardSuccessDanger valid={validation.sameHash} success={"El archivo subido se corresponde con el archivo al que se le aplicó el sello de tiempo."} danger={msgDanger} />
                <CardContainerDescription titulo="Hash del sello" descripcion={validation.timeStampValidation.tokenInfo.hash} />
               {encontrado ?   <CardContainerDescription titulo="Hash del archivo subido" descripcion={hashArchivo} /> :""}
            </div>
        </div>
    );
}

export default ResumenValidado;
